import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function ScrollPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (isDismissed) return;
      
      if (window.scrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isDismissed]);

  const scrollToPricing = () => {
    const pricingSection = document.getElementById("pricing");
    if (pricingSection) {
      pricingSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  if (isDismissed) return null;

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="fixed bottom-6 left-4 right-4 md:left-0 md:right-0 flex justify-center z-50"
        >
          <div className="bg-dark rounded-2xl md:rounded-full px-4 md:px-6 py-3 flex flex-col md:flex-row items-center gap-3 md:gap-4 shadow-2xl border-2 border-pink w-full md:w-auto max-w-md md:max-w-none">
            <button
              onClick={() => setIsDismissed(true)}
              className="absolute top-2 right-3 md:static text-gray-400 hover:text-white transition-colors text-xl leading-none"
            >
              ×
            </button>
            
            <span className="text-white font-medium text-sm md:text-base text-center md:text-left">
              Get started with a chat
            </span>
            
            <div className="flex flex-row gap-2 w-full md:w-auto justify-center">
              <button
                onClick={scrollToPricing}
                className="bg-transparent border border-white text-white px-3 md:px-4 py-2 rounded-full text-sm font-medium hover:bg-white hover:text-dark transition-colors whitespace-nowrap flex-1 md:flex-none"
              >
                View Pricing
              </button>
              
              <a
                href="https://discord.gg/sy5k53rkz4"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-pink text-white px-3 md:px-4 py-2 rounded-full text-sm font-medium hover:bg-opacity-80 transition-colors whitespace-nowrap flex-1 md:flex-none text-center"
              >
                Contact Us
              </a>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
